module.exports = __webpack_public_path__ + "img/logo.589e0b74.png";